function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M78 42.5H44.5L56.7 0 0 70.9h33.4l-12.1 42.5L78 42.5zm63.7 14.2h35.4V85h-35.4V56.7zm56.7 0h35.4V85h-35.4V56.7zm-56.7 49.6h35.4v28.3h-35.4v-28.3zm56.7 0h35.4v28.3h-35.4v-28.3zm-56.7 49.6h35.4v28.3h-35.4v-28.3zm56.7 0h35.4v28.3h-35.4v-28.3zm-56.7 49.6h35.4v28.3h-35.4v-28.3zm56.7 0h35.4v28.3h-35.4v-28.3zM92.1 7.1v120.5H0v155.9h283.5V7.1H92.1zm-63.8 248v-99.2h63.8v14.2H42.5v14.2h49.6v14.2H42.5v14.2h49.6v14.2H42.5v14.2h49.6v14.2H28.3v-.2zm226.8 0H120.4V35.4h134.7v219.7z"
})));